import {
  GET_ACTIVE_DIVERSIONS_REQUEST,
  GET_ACTIVE_DIVERSIONS_SUCCESS,
  GET_ACTIVE_DIVERSIONS_FAILURE,
} from '../constants/ActionTypes';

/**
 * Request a fresh fetch of the active-diversion list. No payload —
 * the endpoint takes no params (tenant scoping is server-side).
 *
 * Dispatched by:
 *   - DiversionsOverview tab on mount (task 10).
 *   - WSNotifications saga on every UPDATE_ROUTE (task 04 dual-dispatch).
 *   - 30s tick / refresh affordances (task 10).
 */
export const getActiveDiversionsRequest = () => ({
  type: GET_ACTIVE_DIVERSIONS_REQUEST,
});

/**
 * Success — the API returned the list. The saga (task 04) extracts
 * the array from the axios response envelope and passes it here.
 *
 * @param {Array<Object>} list - DiversionStatusResponse[] (12 fields each;
 *   see src/api/Diversion.js JSDoc for the field set).
 */
export const getActiveDiversionsSuccess = list => ({
  type: GET_ACTIVE_DIVERSIONS_SUCCESS,
  payload: { list },
});

/**
 * Failure — the API call threw or returned a 5xx. The error object is
 * the normalised error from axios.js's response interceptor (shape:
 * { messages, errors, status }).
 *
 * The saga (task 04) ALSO dispatches showErrorNotification(error.messages)
 * for the toast — this action is only for the reducer's error state, so
 * the overview component can render an inline error if it wants to.
 *
 * @param {Object} error - normalised axios error from src/api/axios.js:42-46
 */
export const getActiveDiversionsFailure = error => ({
  type: GET_ACTIVE_DIVERSIONS_FAILURE,
  payload: { error },
});
